/* TODO: t() */
import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import cx from 'classnames';

import { FreshbooksBusinessAccount } from '../../../types/shared/Freshbooks';
import { Button, Modal } from '../../uiold';
import { themeColors } from '../../uiold/Constants';
import LoadingIndicator from '../../uiold/LoadingIndicator';

let styles = StyleSheet.create({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    border: '10px solid transparent',
  },
  menuItem: {
    padding: 10,
  },
  menuItemText: {
    textAlign: 'left',
  },
  hoveredMenuItem: {
    backgroundColor: themeColors.grey,
  },
});

type Props = {
  businessAccounts: Array<FreshbooksBusinessAccount>;
  isLoading: boolean;
  onClick: (businessAccount: FreshbooksBusinessAccount) => void;
};

export default class BusinessAccountDialog extends Component<Props> {
  static defaultProps = {
    isLoading: false,
  };

  render() {
    let { isLoading } = this.props;
    return (
      <Modal
        isVisible
        title="Select a Business Account"
        isCloseButtonShown={false}
        canEscapeKeyClose={false}
      >
        <Modal.Body>
          <div
            className={cx(css(styles.root), 'form-element-menu popover-menu')}
          >
            {isLoading ? <LoadingIndicator /> : this._renderBusinessAccount()}
          </div>
        </Modal.Body>
      </Modal>
    );
  }
  _renderBusinessAccount(): React.ReactNode {
    let { businessAccounts, onClick } = this.props;
    return businessAccounts.map((businessAccount) => (
      <Button
        key={businessAccount.id}
        onPress={() => onClick(businessAccount)}
        style={styles.menuItem}
        hoverStyle={styles.hoveredMenuItem}
        title={businessAccount.name}
        textStyle={styles.menuItemText}
      />
    ));
  }
}
